/**
 * Environment utilities for the application
 */

/**
 * Check if the application is running in development mode
 */
export const isDevelopment = (): boolean => {
  return import.meta.env.DEV || import.meta.env.VITE_DEV_MODE === 'true';
};

/**
 * Get environment variables with type safety
 */
export const getEnvVar = (key: keyof ImportMetaEnv): string => {
  const value = import.meta.env[key];
  if (value === undefined) {
    throw new Error(`Environment variable ${key} is not defined`);
  }
  return value;
};
